import { render, staticRenderFns } from "./AsssistantSubmit.vue?vue&type=template&id=65ebbbc8"
import script from "./AsssistantSubmit.vue?vue&type=script&lang=ts"
export * from "./AsssistantSubmit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports